import { BetsReportingMessageChannels } from "../message";
export const QueryTypes = BetsReportingMessageChannels;
//# sourceMappingURL=betsReporting.js.map